import { Typography } from "@mui/material";
import { Page } from "../components/Page";
import { CompetitionCatalog } from "./CompetitionCatalog";

export function CompetitionList() {
  return (
    <Page
      title="Competitions"
      description="Bring your group together with sweeps and competitions for the big occasion."
    >
      <Typography component="h2" variant="h4" sx={{ mb: 1 }}>
        Competitions
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: "60ch" }}>
        Bring your group together with sweeps and competitions for the big
        occasion.
      </Typography>
      <CompetitionCatalog />
    </Page>
  );
}
